import store from '@/store';
import { hasModule } from '@/utils/module';

export const BLOQUEAR = 'bloquear';
export const PERMITIR = 'permitir';

/** Opções do padrão da LOJA (Configurações). */
export const opcoesAcaoLoja = [
    { value: BLOQUEAR, text: 'Bloquear a venda do item' },
    { value: PERMITIR, text: 'Permitir a venda (o estoque fica negativo)' },
];

const rotuloCurto = acao => (acao === PERMITIR ? 'Permitir a venda' : 'Bloquear a venda');

export const acaoPadraoLoja = () =>
    store.state.configuracoes?.acao_sem_estoque === PERMITIR ? PERMITIR : BLOQUEAR;

/**
 * Opções do ITEM (cadastro de produto, complemento e ingrediente).
 */
export const opcoesAcaoItem = () => [
    { value: null, text: `Usar o padrão da loja (${rotuloCurto(acaoPadraoLoja())})` },
    { value: BLOQUEAR, text: 'Bloquear a venda' },
    { value: PERMITIR, text: 'Permitir a venda (estoque negativo)' },
];

/** Ação em vigor para o item: a dele, se escolheu; senão a da loja. */
export const acaoSemEstoque = item =>
    item?.acao_sem_estoque === BLOQUEAR || item?.acao_sem_estoque === PERMITIR
        ? item.acao_sem_estoque
        : acaoPadraoLoja();

export const bloqueiaVenda = item => acaoSemEstoque(item) === BLOQUEAR;

export const controleEstoqueAtivo = () =>
    !!store.state.configuracoes?.controle_estoque && hasModule('CONTROLE_ESTOQUE');

/** O item está sem saldo E foi configurado para impedir a venda por causa disso. */
export const semEstoqueBloqueando = item =>
    controleEstoqueAtivo()
    && !!item?.controle_estoque
    && +item?.estoque <= 0
    && bloqueiaVenda(item);
